import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import ActionCreator from "../ActionCreator";
import * as Widget from "./Widget2";
import "../global-styles";

class FindButton extends Component {
  render() {
    let { data, navActions } = this.props;

    return (
      <Wrapper css="margin: 15px;" onClick={() => navActions.push(data.link)}>
        <Widget.Col
          justify="center"
          align="center"
          css="width: 100%; height: 100%;"
        >
          <MainIcon src={`/images/pages/landing/icon-${data.img}.png`} css="" />
          <Text>{data.title}</Text>
        </Widget.Col>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  width: 214px;
  height: 214px;

  background-image: url("/images/pages/landing/icon01.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;

  cursor: pointer;

  :active {
    position: relative;
    top: 1px;
    left: 1px;
  }

  @media screen and (max-width: 1000px) {
    width: 180px;
    height: 180px;
  }

  @media screen and (max-width: 800px) {
    width: 150px;
    height: 150px;
  }

  @media screen and (max-width: 720px) {
    width: 214px;
    height: 214px;
  }

  @media screen and (max-width: 450px) {
    width: 130px;
    height: 130px;
  }

  ${props => props.css || ""};
`;

const MainIcon = styled.img`
  width: 80px;
  height: 80px;
  margin-bottom: 15px;

  @media screen and (max-width: 800px) {
    width: 50px;
    height: 50px;
  }

  @media screen and (max-width: 720px) {
    width: 80px;
    height: 80px;
  }

  @media screen and (max-width: 450px) {
    width: 45px;
    height: 45px;
    margin-bottom: 0px;
  }

  ${props => props.css || ""};
`;

const Text = styled.div`
  letter-spacing: 2.36px;
  line-height: 30px;
  font-weight: bold;
  font-size: 22px;
  color: #4e4e4e;

  @media screen and (max-width: 450px) {
    font-size: 18px;
  }
`;

export default connect(
  null,
  ActionCreator
)(FindButton);
